import { bool, notEmpty } from '@ember/object/computed';
import Em from 'ember';
export default Em.Object.extend({
  joinWithPrevious: false,
  shouldRerender: false,
  blocksToRemove: [],
  updatesCaret: bool('blockRange'),
  hasBlocksToAdd: notEmpty('blocksToAdd'),
  hasBlocksToRemove: notEmpty('blocksToRemove')
});